import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import http from '@/utils/http.service';

export const useUpdateAgendaSlotReservationTagMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({
      reservationId,
      tag,
    }: {
      reservationId: string;
      tag?: string;
    }) => {
      return http.agendaSlotReservations
        .updateTag(reservationId, { tag })
        .then((response) => {
          return response;
        });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['office-agenda-slots'],
      });
      toast.success(t('http.update-agenda-slot-reservation-tag.success'));
    },
    onError: () => {
      toast.error(t('http.update-agenda-slot-reservation-tag.error'));
    },
  });
};
